"use strict";
import { useContext, useMemo } from "react";
import { AuthContext } from "./AuthContext";
export function usePermissions() {
  const { permissions, setPermissions } = useContext(AuthContext);
  return useMemo(() => {
    return [permissions, setPermissions];
  }, [permissions, setPermissions]);
}
